import { createSelector, createSlice } from "@reduxjs/toolkit";

import { IChangeHospitalModuleName } from "@/models/doctor";

import { ITopBarItems } from "@/store/slices/doctor/models/topNavigationSliceModel";

import { RootState } from "@/store/store";

const topBarItemsInitialState = {
  isProfileOpen: false as boolean,
  isReviewOpen: false as boolean,
  isClinicalTeamOpen: false as boolean,
  isTemplatesOpen: false as boolean,
  isChangeHospitalOpen: false as boolean,
  isLogoutOpen: false as boolean,
  isHelpSupportOpen: false as boolean,
  isMakeAppointmentFromNavBar: false as boolean,
  isMakeAppointmentFromClinicPatients: false as boolean,
};
const addPatientInitialState = {
  appointmentCreateOpen: false as boolean,
  mobileCheck: false as boolean,
  otpVerify: false as boolean,
  admiPatient: false as boolean,
};
const initialState = {
  topBarItems: topBarItemsInitialState as ITopBarItems,
  addPatient: addPatientInitialState,
  changeHospitalModuleName: "" as IChangeHospitalModuleName,
};
const topNavigationSlice = createSlice({
  name: "topNavDoctor",
  initialState,
  reducers: {
    resetTopNavigation: () => initialState,
    setTopBarDropdownItems: (state: any, action) => {
      state.topBarItems = {
        ...state.topBarItems,
        [action.payload]: !state.topBarItems[action.payload],
      };
    },
    setTopBarDropdownMultipleItems: (state: any, action) => {
      let newObj = {};
      action.payload.forEach((item: any) => {
        newObj[item] = !state.topBarItems[item];
      });
      state.topBarItems = {
        ...state.topBarItems,
        ...newObj,
      };
    },
    setAddPatient: (state: any, action) => {
      state.addPatient = {
        ...state.addPatient,
        [action.payload.field]: action.payload.value,
      };
    },
    setChangeHospitalModuleName: (state, action) => {
      state.changeHospitalModuleName = action.payload;
    },
  },
});

const selectTopNavigation = (state: RootState) => state.topNavigation;

export const topNavigation = createSelector(
  [selectTopNavigation],
  (selectTopNavigation) => {
    return {
      topBarItems: selectTopNavigation.topBarItems,
      addPatient: selectTopNavigation.addPatient,
      changeHospitalModuleName: selectTopNavigation.changeHospitalModuleName,
    };
  }
);

export const {
  resetTopNavigation,
  setTopBarDropdownItems,
  setAddPatient,
  setChangeHospitalModuleName,
  setTopBarDropdownMultipleItems,
} = topNavigationSlice.actions;
export default topNavigationSlice.reducer;
